// extracted by mini-css-extract-plugin
export default {"header":"header__8cefX","NavMenu":"NavMenu__wSLv8","logo":"logo__x7IqJ","addressContainer":"addressContainer__gGshn","addressItem":"addressItem__TPlMw","address":"address__FNdXE"};